import tokenService from "@/helpers/tokenService.js"
import advanceReportingConstants from "@/constants/advanceReportingConstants"
import securlyPlatformConfig from "@/configs/securlyPlatformConfig.js"
import cookieService from "./cookies"

export const getSecurlyTokenFromCookie = () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("securly_token="))
    ?.split("=")[1]

  return token ? decodeURIComponent(token) : null
}

export const loadSecurlyPlatformScript = () => {
  return new Promise((resolve, reject) => {
    if (window.SecurlyPlatform) {
      resolve(window.SecurlyPlatform)
      return
    }

    const existingScript = document.querySelector(
      `script[src="${securlyPlatformConfig.scriptUrl}"]`
    )
    if (existingScript) {
      existingScript.addEventListener("load", () =>
        resolve(window.SecurlyPlatform)
      )
      existingScript.addEventListener("error", reject)
      return
    }

    const script = document.createElement("script")
    script.src = securlyPlatformConfig.scriptUrl
    script.async = true
    script.onload = () => resolve(window.SecurlyPlatform)
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export const logoutSecurlyPlatform = async () => {
  try {
    const auth = await loadSecurlyPlatformScript()
    if (!auth) {
      return
    }

    await auth.Init(
      securlyPlatformConfig.clientId,
      securlyPlatformConfig.issuer
    )
    await auth.Logout()
    cookieService.removeAllCookies()
  } catch {
    cookieService.removeAllCookies()
    // Ignore SDK logout errors so local session clear still continues
  }
}

export const redirectByUserRole = (user) => {
  localStorage.setItem("showAnnouncements", true)

  if (user?.role_id === 1) {
    window.location.replace("/passes/create")
  } else if (user?.role_id === 2) {
    window.location.replace(advanceReportingConstants.PATHS.REPORT)
  } else {
    window.location.replace("/dashboard")
  }
}

export const completeWebLogin = (store, data) => {
  if (data?.user?.redirect) {
    window.location.replace(data.user.redirect)
    return
  }

  if (data?.access_token) {
    tokenService.saveDevToken(data.access_token)
  }

  if (data?.ws?.token) {
    store.dispatch("authentication/saveToken", data.ws.token)
  }

  if (data?.user?.created_at) {
    store.commit("authentication/SET_USER", data.user)
  }

  if (
    data?.user?.force_password_change_at == null &&
    data?.user?.is_manual === true
  ) {
    window.location.replace("/password/reset")
    return
  }

  localStorage.setItem("showAnnouncements", true)

  redirectByUserRole(data?.user)
}
